/* by this component video answer should be edited and saved */
import React, { useState } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { selectors } from "reducers";
import { PageHeader } from 'components/ui';
import Text from "../../components/TextComponent";
import SelectDropdown from "components/forms/select-dropdown";

const AddNewArticle = ({
  Article,
  companyOptions,
  onSave
}) => {
  const [title, changeTitle] = useState(Article.title);
  const [link, changeLink] = useState(Article.link);
  const [company, setCompany] = useState(Article.company);

  return (
    <div className="dd_root" >
      <PageHeader question='Add/Update Question Answers' />
      <div className="dd_row">
        <div className="dd_col-6">
          <Text maxLength={90} id="title" value={title} placeholder="Enter Title" onChange={({ target: { value } }) => changeTitle(value)} />
        </div>
        <div className="dd_col-6">
          <Text maxLength={90} id="link" value={link} placeholder="Enter Link" onChange={({ target: { value } }) => changeLink(value)} />
        </div>
        <div className="dd_col-6">
          <div className="company_container">
            Company:
            <SelectDropdown
              id="companyGUID"
              placeHolder="Choose An Option..."
              options={companyOptions}
              value={company}
              onChange={value => {
                setCompany(value);
              }}
            />
          </div>
        </div>
        <div className="dd_col-12">
          <button
            onClick={() => onSave({ link, title, company, article_id: Article.article_id , active: Article.active})}
            disabled={(title.trim().length === 0 || link.trim().length === 0)}>
            Save
         </button>
        </div>
      </div>
    </div>
  );
}

AddNewArticle.propTypes = {
  companyOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  Article: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string,
    article_id: PropTypes.string,
    company: PropTypes.string,
    active: PropTypes.bool
  }),
  onSave: PropTypes.func
};

export default connect(
  state => ({
    companyOptions: selectors.getFormOptionsCompany(state)
  })
)(AddNewArticle);
